export default {
    msd: {
        overview: {
            header: {
                lgsmart : "LG",
                dms     : "ELO",
                state   : "S",
                lmstate : "LM",
                sitetype: "A",
                fabricNo: "Fabrik-Nr.",
                id      : "ID",
                customer: "Kunde",
                group   : "Kundengruppe",
                ve      : "VE",
                ve2     : "VE2",
                ve3     : "VE3",
                branch  : "Bereich",
                street  : "Straße",
                city    : "PLZ Ort",
            }
        },

        company: {
            id     : "HC-ID",
            name   : "Name",
            nameAdd: "Ergänzung zur Anschrift",
            zip    : "PLZ",
            city   : "Stadt",
            street : "Strasse",
            status : "Status"
        },

        operator: {
            create    : "Einen neuen Betreiber zuordnen",
            assign    : "Betreiber zuordnen",
            label     : "Zuordnen",
            input     : "Betreiber"
        },

        recipient: {
            create    : "Einen neuen Leistungs-/Rechnungsempfänger anlegen",
            title     : "Rechnungs- / Leistungsempfänger",
            lim       : "Liftmanagement/Verwender",
            limshort  : "Liftman./Verwender",
            incmanagement: "Ereignisbearbeitung",
            inc       : "Empfängeradresse in Ereignissen",
            benefit   : "Leistungsempfänger",
            invoice   : "Rechnungsempfänger",
            costs     : "Wartung, Notruf, ZÜS",
            incident  : "Störung",
            repair    : "Reparaturaufträge",
            debitor   : "Debitor",
        },

        customer: {
            overview: {
                header: {
                    limactive  : "aktiv",
                    liminactive: "inaktiv",
                    dlsactive  : "aktiv",
                    dlsinactive: "inaktiv",
                    others     : "Sonstige"
                }
            },
            recipient: {
                all    : "Rechnungs-/Leistungsempfänger",
                benefit: "Leistungsempfänger",
                invoice: "Rechnungsempfänger"
            },
            responsibles: {
                title: "Verantwortliche Liftmanager",
                refresh: {
                    info: "<p>Beim Aktualisieren werden ggf. neue VE's ergänzt. Die Zuordnung von nicht mehr verwendeten VE's werden gelöscht.</p> <p>Soll die Aktualisierung nun durchgeführt werden?</p>",
                }
            }
        },

        service: {
            role: {
                mnt: {
                    name : "Wartungsnehmer",
                    label: "WN"
                },
                esc: {
                    name : "Notrufnehmer",
                    label: "NN"
                },
                adm: {
                    name : "Verwalter",
                    label: "VW"
                },
                fcm: {
                    name : "Facilitymanager",
                    label: "FM"
                },
                exe: {
                    name : "Ausführendes Unternehmen",
                    label: "AU"
                },
                mnf: {
                    name : "Hersteller",
                    label: "H"
                },
                nexe: {
                    name : "Kein ausf. Unternehmen",
                    label: "AU"
                },
                ocp: {
                    name : "Nur Komponenten",
                    label: "NK"
                },
                srv: {
                    name : "Service",
                    label: "S"
                },
            },
            menu: {
                create: {
                    tooltip: "Neues Unternehmen anlegen"
                }
            }
        }
    },
}